import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import PageNumberRenderer from "./PageNumberRenderer";
import { Box, Tooltip } from "@mui/material";

interface Message {
  text: string;
}

interface MarkdownProps {
  message: Message;
  handleLinkClick?: (href: string, param: number, e?: React.MouseEvent<HTMLAnchorElement>) => void;
}

const MarkdownRenderer: React.FC<MarkdownProps> = ({ message, handleLinkClick }) => {
  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, title, children }) => (
            <span className="tooltip">
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => handleLinkClick?.(href as string, 1, e)}
              >
                {children}
              </a>
              {title && <span className="tooltiptext">{title}</span>}
            </span>
          ),
          em: ({ children }) => (
            <span>
              <PageNumberRenderer handleLinkClick={handleLinkClick}>{children}</PageNumberRenderer>
            </span>
          ),
          img: ({ src, title, alt }) => (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip title={title}>
                <img
                  src={src}
                  alt={alt}
                  style={{
                    maxHeight: "460px",
                    height: "auto",
                    width: "auto",
                    maxWidth: "100%",
                  }}
                />
              </Tooltip>
            </Box>
          ),
        }}
      >
        {message.text}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
